import { LitElement, html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';

// TODO delete base.styles
// import baseStyles from '../../../base/base.styles';
import componentStyles from './fil-label.styles.js';

/**
 * @tag fil-label
 * @property {string} [labelRequired] Aria label for the required element in the component
 * @property {string} [assistiveText] Assistive text of the component
 * @property {boolean} [disabled=false] Disabled attribute of the component
 * @property {string} [errorText] Error to be shown for the component
 * @property {string} [for] for attribute of the component
 * @property {string} [label] Label of the component
 * @property {boolean} [required=false] HTML required attribute of the component
 * @property {string} [tooltip] Tooltip of the component
 * @property {object} [tooltipExtraProps] Extra options needed to show tooltip inside the component
 * @property {'standard'|'small'} [size="standard"] Size of the component
 * @slot {"content"} - The html content
 */
export class FilLabel extends LitElement {
  static properties = {
    labelRequired: { type: String },
    assistiveText: { type: String },
    disabled: { type: Boolean },
    errorText: { type: String },
    for: { type: String },
    label: { type: String },
    required: { type: Boolean },
    tooltip: { type: String },
    tooltipExtraProps: { type: Object },
    size: { type: String },
  };

  static styles = [componentStyles];

  constructor() {
    super();
    this.disabled = false;
    this.required = false;
    this.size = 'standard';
    this.labelRequired = 'Required';
  }

  labelTemplate() {
    return html`
      <label
        class="fil-label__label"
        for=${ifDefined(this.for ? this.for : undefined)}
        id="label_${ifDefined(this.for ? this.for : undefined)}"
      >
        ${this.required
          ? html`<span class="fil-label__required" aria-label=${this.labelRequired}>*</span>`
          : null}
        ${this.label}<slot></slot
      ></label>
    `;
  }

  assistiveTextTemplate() {
    return html`<p class="fil-label__assistive-text">${this.assistiveText}</p>`;
  }

  errorTextTemplate() {
    return html`<p class="fil-label__error-text">${this.errorText}</p>`;
  }

  tooltipTemplate() {
    return html`
      <div class="fil-label__tooltip">
        <div class="tooltip">
          <span class="tooltip__toggle">
            <fil-tooltip
              message=${this.tooltip}
              extraProps=${ifDefined(this.tooltipExtraProps)
                ? JSON.stringify({ ...this.tooltipExtraProps })
                : null}
              >${this.tooltip}</fil-tooltip
            >
          </span>
        </div>
      </div>
    `;
  }

  render() {
    const classes = {
      'fil-label--invalid': this.errorText,
      'fil-label--disabled': this.disabled,
      [`fil-label--${this.size}`]: this.size,
    };

    return html`
      <div class="fil-label${classMap(classes)}">
        ${this.labelTemplate()} ${this.assistiveText && this.assistiveTextTemplate()}
        ${this.errorText && this.errorTextTemplate()} ${this.tooltip && this.tooltipTemplate()}
      </div>
    `;
  }
}

export default FilLabel;
